module.exports = __webpack_public_path__ + "img/people27.fe40b6a7.png";